import React, { createContext, useState, useContext, ReactNode } from "react";
import { UsersService } from "../../../services/user/users";
import { useAppContext } from "../../../AppProvider";
import { callSuccessToast, callErrorToast } from "../../../utilities/utilities";

const usersService = new UsersService();

interface SendResetPasswordMailProviderProps {
  id: string;
  children: ReactNode;
  callback?: () => void;
}

interface SendResetPasswordMailContextValue {
  callback?: () => void;
  loader: boolean;
  sendResetPasswordMail: () => void;
}

const SendResetPasswordMailContext = createContext<
  SendResetPasswordMailContextValue | undefined
>(undefined);

const SendResetPasswordMailProvider: React.FC<
  SendResetPasswordMailProviderProps
> = ({ id, children, callback }) => {
  const { dictionary } = useAppContext();
  const [loader, setLoader] = useState<boolean>(false);

  const sendResetPasswordMail = (): void => {
    if (!id) {
      return;
    }

    setLoader(true);
    usersService
      .sendResetPasswordMail(id)
      .then(() => {
        callSuccessToast(dictionary.messages.email_sent_successfully);
        setLoader(false);
        if (callback) callback();
      })
      .catch((err) => {
        callErrorToast(err);
        setLoader(false);
      });
  };

  return (
    <SendResetPasswordMailContext.Provider
      value={{
        callback,
        loader,
        sendResetPasswordMail,
      }}
    >
      {children}
    </SendResetPasswordMailContext.Provider>
  );
};

const useSendResetPasswordMailContext =
  (): SendResetPasswordMailContextValue => {
    const context = useContext(SendResetPasswordMailContext);
    if (!context) {
      throw new Error(
        "useHandlerContext must be used within a HandlerProvider"
      );
    }
    return context;
  };

export { SendResetPasswordMailProvider, useSendResetPasswordMailContext };
